import { render, staticRenderFns } from "./realtor.vue?vue&type=template&id=76f4bc12&scoped=true"
import script from "./realtor.vue?vue&type=script&lang=js"
export * from "./realtor.vue?vue&type=script&lang=js"
import style0 from "./realtor.vue?vue&type=style&index=0&id=76f4bc12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f4bc12",
  null
  
)

export default component.exports